/**
Project: Voice Panel (c)
Title: General Reducer
Description: Reducer for the general data
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/

import { PAGE_WAIT_DIALOG_DATA, COUNTRY_STATES_DATA, COMMUNICATION_PLATFORMS_DATA, USER_CONSENT_DATA } from "./constants";

const pageWaitDialogData = {
  displayStatus: false,
  spinnerSize: "medium",
  labelText: "",
  labelPosition: "below",
};
const INIT_STATE = {
  pageWaitDialogData: pageWaitDialogData,
  countryStatesData: [],
  userConsentData:null
};

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case PAGE_WAIT_DIALOG_DATA:
      return {
        ...state,
        pageWaitDialogData: action.payload,
      };
    case COUNTRY_STATES_DATA:
      return {
        ...state,
        countryStatesData: action.payload,
      };
      case COMMUNICATION_PLATFORMS_DATA:
        return {
          ...state,
          communicationPlatformsData: action.payload,
        };
        case USER_CONSENT_DATA:
          return {
            ...state,
            userConsentData:action.payload
          }
    default:
      return state;
  }
};
